import React from 'react';
import t from '~t';
import { Label } from '~ui';

export default function ProPrice({ subscription: { price } }) {
  if (!price) return null;

  return (
    <>
      <Label>{t.s('price')}</Label>
      <div className='self-center'>{price.beautiful}</div>
    </>
  );
}
